export const formatPhonesNumber = (numbers) => {
  return numbers
    .split(" ") // Разделяем номера по пробелу
    .map((num) => {
      // Форматируем каждый номер
      if (num.length === 11 && num.startsWith("7")) {
        return `+7 (${num.slice(1, 4)}) ${num.slice(4, 7)}-${num.slice(
          7,
          9
        )}-${num.slice(9)}`;
      }
      return num; // Если номер не соответствует формату, возвращаем как есть
    })
    .join("\n"); // Соединяем отформатированные номера через запятую
};

export const formatPhoneNumber = (number) => {
    let phone = number
  // Форматируем каждый номер
  if (phone.length === 11 && phone.startsWith("7")) {
    phone = `+7 (${phone.slice(1, 4)}) ${phone.slice(4, 7)}-${phone.slice(
      7,
      9
    )}-${phone.slice(9)}`;
  }
  return phone; // Если номер не соответствует формату, возвращаем как есть
};
